import { defineMessages } from 'react-intl';

export default defineMessages({
  title: { defaultMessage: 'Add {asset} to your browser wallet' },
});
